import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["email"];

  focus() {
    document.getElementById("user_email").focus();
  }
}
